import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import {
  getAnnouncements, markAnnouncementsSeen,
  getAdminAnnouncements, createAnnouncement, updateAnnouncement, deleteAnnouncement,
} from '../services/api.js'

export function useAnnouncements() {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: getAnnouncements,
    staleTime: 5 * 60 * 1000,
  })
}

export function useMarkAnnouncementsSeen() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: markAnnouncementsSeen,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['announcements'] }),
  })
}

export function useAdminAnnouncements() {
  return useQuery({ queryKey: ['adminAnnouncements'], queryFn: getAdminAnnouncements })
}

export function useAdminAnnouncementMutations() {
  const qc = useQueryClient()
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ['adminAnnouncements'] })
    qc.invalidateQueries({ queryKey: ['announcements'] })
  }
  const err = (e) => toast.error(e?.response?.data?.message || 'Opération impossible')

  const create = useMutation({
    mutationFn: createAnnouncement,
    onSuccess: () => { toast.success('Annonce créée'); invalidate() },
    onError: err,
  })
  const update = useMutation({
    mutationFn: ({ id, payload }) => updateAnnouncement(id, payload),
    onSuccess: () => { toast.success('Annonce mise à jour'); invalidate() },
    onError: err,
  })
  const remove = useMutation({
    mutationFn: deleteAnnouncement,
    onSuccess: () => { toast.success('Annonce supprimée'); invalidate() },
    onError: err,
  })
  return { create, update, remove }
}
